import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const repairsPlugin = createPlugin({
  id: 'repairs',
  routes: {
    root: rootRouteRef,
  },
});

export const RepairsHomePage = repairsPlugin.provide(
  createRoutableExtension({
    name: 'RepairsHomePage',
    component: () =>
      import('./components/repairs_home').then(m => m.repairsHomePage),
    mountPoint: rootRouteRef,
  }),
);

export const RepairPage = repairsPlugin.provide(
  createRoutableExtension({
    name: 'RepairPage',
    component: () =>
      import('./components/repair_page').then(m => m.RepairPage),
    mountPoint: rootRouteRef,
  }),
);
